<script>
import Template from '{Template}/Admin/Pages/Admin/Launchpads/Form.template'
import AppLayout from '@/Layouts/AdminLayout'
import NavButtonLink from "@/Jetstream/NavButtonLink";
import TextInput from '@/Jetstream/TextInput'
import TextareaInput from "@/Jetstream/TextareaInput";
import LoadingButton from "@/Jetstream/LoadingButton";
import TrashedMessage from "@/Jetstream/TrashedMessage";
import SelectInput from "@/Jetstream/SelectInput";
import EmptyColumn from "@/Jetstream/EmptyColumn";
import JetInputError from '@/Jetstream/InputError';

const defaultForm = {
    'name': null,
    'description': null,
    'currency_id': null,
    'network_id': null,
    'rate': null,
    'min_buy': null,
    'max_buy': null,
    'soft_cap': null,
    'hard_cap': null,
    'start_time': null,
    'end_time': null,
    'status': true,
};

export default Template({
    components: {
        NavButtonLink,
        AppLayout,
        TextInput,
        TextareaInput,
        LoadingButton,
        TrashedMessage,
        SelectInput,
        EmptyColumn,
        JetInputError
    },
    props: {
        isEdit: {
            type: Boolean,
            default: false,
        },
        errors: Object,
        launchpad: Object,
        networks: Array,
        currencies: Array,
    },
    remember: 'form',
    data() {
        return {
            sending: false,
            form: Object.assign({}, defaultForm),
        }
    },
    mounted() {
        if(this.isEdit) {
            this.form = this.launchpad;
        }
    },
    computed: {
        subTitle: function () {
            return this.isEdit ? this.launchpad.name : 'Create';
        },
        actionButtonTitle: function () {
            return this.isEdit ? 'Update Launchpad' : 'Create Launchpad';
        },
    },
    methods: {
        submit() {

            if(this.$page.props.mode == "readonly") {
                return this.$toast.warning('In Demo Version we enabled READ ONLY mode to protect our demo content.')
            }

            let afterRequest = {
                onStart: () => this.sending = true,
                onFinish: () => this.sending = false,
                onSuccess: () => {
                    this.$toast.open('Database updated');
                },
                onError: () => {
                    this.$toast.error('There are some form errors');
                }
            };

            if(this.isEdit) {
                this.$inertia.put(this.route('admin.launchpads.update', this.launchpad.id), this.form, afterRequest);
            } else {
                this.$inertia.post(this.route('admin.launchpads.store'), this.form, afterRequest);
            }
        },
        destroy() {

            if(this.$page.props.mode == "readonly") {
                return this.$toast.warning('In Demo Version we enabled READ ONLY mode to protect our demo content.')
            }

            if (confirm('Are you sure you want to delete this launchpad?')) {
                this.$inertia.delete(this.route('admin.launchpads.destroy', this.launchpad.id), {
                    onSuccess: () => { this.$toast.open('Launchpad was deleted'); }
                })
            }
        },
    },
});
</script>
